import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import {
  Table, Select, notification, Button,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import TenantActions from '@Actions/tenantActions';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import Helpers from '@Apis/helpers';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const TallyMapUOM = ({
  user, getTallyConnections, tallyConnections, connectTenantToTallyLocation,
  connectTenantToTallyLocationLoading, setStep, getTallyConnectionsLoading,
  stepNumber,
}) => {
  const [uomData, setUomData] = useState([]);
  const [uomDataPull, setUomDataPull] = useState([]);
  const [uomOptions, setUomOptions] = useState([]);
  const [uomOptionsPull, setUomOptionsPull] = useState([]);
  const [tallyUOMMapping, seTallyUOMMapping] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState('');
  const integrationTallyIdURL = Number(Helpers.getValueFromUrl('it_id'));

  useEffect(() => {
    getTallyConnections(user?.tenant_info?.org_id);
  }, []);

  const tallyConnectionsFilteredData = tallyConnections?.filter((connection) => connection?.it_id === integrationTallyIdURL);

  useEffect(() => {
    if (tallyConnectionsFilteredData) {
      seTallyUOMMapping(tallyConnectionsFilteredData[0]?.units_mapping?.reduce((a, v) => ({ ...a, [v?.uom_name]: v?.tally_stock_unit_name }), {}));
    }
  }, [tallyConnections]);

  useEffect(() => {
    if (tallyUOMMapping) {
      const uoms = Object.values(user?.tenant_info?.uom_groups_master)?.filter((item) => item?.uoms)?.map((uomGroup) => [...uomGroup.uoms]).flat(1);
      setUomOptions(tallyConnectionsFilteredData[0]?.units?.map((item) => item.name) || []);
      setUomOptionsPull(uoms || []);
      const copyUomData = uoms?.map((uom) => ({
        uomName: uom.uom_name, tallyUomName: tallyUOMMapping[uom?.uom_name], key: uuidv4(),
      }));

      if (tallyConnectionsFilteredData[0]?.pull_product_units_mapping?.length) {
        setUomDataPull(tallyConnectionsFilteredData?.[0]?.units?.map((unit) => {
          const matchedObject = tallyConnectionsFilteredData?.[0]?.pull_product_units_mapping?.find((item) => (item?.tally_unit_name === unit?.name));
          return {
            ...unit,
            key: uuidv4(),
            tally_unit_name: matchedObject?.tally_unit_name || unit?.name,
            uom_id: matchedObject?.uom_id,
            uom_name: matchedObject?.uom_name,
          }
        }))
      } else {
        const copyUomDataPull = tallyConnectionsFilteredData[0]?.units?.map((uom) => ({
          tally_unit_name: uom?.name, key: uuidv4(),
        }));
        setUomDataPull(copyUomDataPull);
      }

      setUomData(copyUomData);
    }
  }, [tallyUOMMapping]);

  const updateTableValue = (key, value, label) => {
    const data = uomData.map((tenant) => {
      if (tenant.key === key) {
        // eslint-disable-next-line no-param-reassign
        tenant[label] = value;
        return tenant;
      }
      return tenant;
    });
    setUomData(data);
  };

  const updateTableValuePull = (key, value, label) => {
    const data = uomDataPull.map((tenant) => {
      if (tenant.key === key) {
        // eslint-disable-next-line no-param-reassign
        tenant[label] = value;
        return tenant;
      }
      return tenant;
    });
    setUomDataPull(data);
  };

  const getDataSource = (data) => (data ? JSON.parse(JSON.stringify(data?.filter((tenant) => !tenant.is_deleted))) : []);

  const columns = [
    {
      title: 'Procuzy UOM',
      width: '312px',
      render: (record) => (
        <div>

          {record?.uomName}
        </div>
      ),
    },
    {
      title: 'Tally UOM',
      render: (record) => (
        <div>
          <PRZSelect
            onChange={(value) => {
              updateTableValue(record?.key, value, 'tallyUomName');
            }}
            value={record.tallyUomName}
            hideTitle
            disabled={connectTenantToTallyLocationLoading}
            showSearch
            allowClear
            filterOption={(input, option) =>
              option?.children.toLowerCase().includes(input.toLowerCase())
            }
            placeholder=""
          >
            {uomOptions?.map((uom) => (
              <Option value={uom} key={uom}>
                {uom}
              </Option>
            ))}

          </PRZSelect>
        </div>
      ),
    },
  ];

  const columnsPullUnit = [
    {
      title: 'Tally UOM',
      width: '312px',
      render: (record) => (
        <div>
          {record?.tally_unit_name}
        </div>
      ),
    },
    {
      title: 'Procuzy UOM',
      render: (record) => (
        <div>
          <PRZSelect
            onChange={(value) => {
              const data = uomOptionsPull?.filter((item) => item.uom_id === value)[0];
              updateTableValuePull(record?.key, data?.uom_name, 'uom_name');
              updateTableValuePull(record?.key, data?.uom_id, 'uom_id');
            }}
            value={record.uom_name}
            hideTitle
            disabled={connectTenantToTallyLocationLoading}
            showSearch
            allowClear
            filterOption={(input, option) =>
              option?.children.toLowerCase().includes(input.toLowerCase())
            }
            placeholder=""
          >
            {uomOptionsPull?.map((uom) => (
              <Option value={uom?.uom_id} key={uom?.uom_id}>
                {uom?.uom_name}
              </Option>
            ))}

          </PRZSelect>
        </div>
      ),
    },
  ];

  const isDataValid = (data, dataPull) => {
    for (let i = 0; i < data?.length; i++) {
      if (!data[i]?.tallyUomName) {
        return false;
      }
    }
    for (let i = 0; i < dataPull?.length; i++) {
      if (!dataPull[i]?.uom_id) {
        return false;
      }
    }
    return true;
  };

  const handleSubmit = () => {
    setFormSubmitted(true);
    // if (isDataValid(uomData, uomDataPull)) {
    const unitsMapping = uomData?.map((record) => (
      {
        tally_stock_unit_name: record.tallyUomName,
        uom_name: record?.uomName,
      }
    ));
    const unitsMappingPull = uomDataPull?.map((record) => (
      {
        uom_id: record.uom_id,
        uom_name: record.uom_name,
        tally_unit_name: record.tally_unit_name,
      }
    ));
    const payload = {
      ...tallyConnectionsFilteredData[0],
      units_mapping: unitsMapping,
      pull_product_units_mapping: unitsMappingPull,
    };

    connectTenantToTallyLocation(payload, () => {
      setStep(stepNumber + 1);
    });
    // } else {
    //   notification.error({
    //     message: 'Please select uom for every tally uom',
    //     placement: 'top',
    //     duration: 4,
    //   });
    // }
  };

  return (
    <Fragment>
      {(getTallyConnectionsLoading)
        ? (
          <div className="tally-integration__loader__wrapper">

            {[...Array(5).keys()].map((item) => (
              <div key={item} className="tally-integration__loader-row">
                <div className="loadingBlock  tally-integration__loader__line1" />
                <div className="loadingBlock  tally-integration__loader__line2" />
                <div className="loadingBlock  tally-integration__loader__line3" />
              </div>
            ))}
            <div className="loadingBlock tally-integration__loader__line-btn1" />
            <div className="loadingBlock tally-integration__loader__line-btn2" />
          </div>
        )
        : (
          <div>
            <div className="integration-step__wrapper">
              <div className="ant-row">
                <div className="ant-col-md-18">
                  <Table
                    title={() => "Map Procuzy's unit of measures with Tally"}
                    columns={columns}
                    loading={getTallyConnectionsLoading || connectTenantToTallyLocationLoading}
                    dataSource={getDataSource(uomData) || []}
                    size="small"
                    pagination={false}
                  />
                  &nbsp;&nbsp;
                  <Table
                    title={() => 'Map unit of measures exported from Tally'}
                    columns={columnsPullUnit}
                    loading={getTallyConnectionsLoading || connectTenantToTallyLocationLoading}
                    dataSource={getDataSource(uomDataPull) || []}
                    size="small"
                    pagination={false}
                  />
                </div>
              </div>
            </div>
            <div className="integration-step__footer" style={{ display: 'flex', paddingTop: '10px', paddingLeft: '15px' }}>
              <Button
                type="primary"
                onClick={() => setStep(3)}
                disabled={connectTenantToTallyLocationLoading}
                ghost
              >
                Back
              </Button>
              &nbsp;&nbsp;
              <Button
                type="primary"
                onClick={() => handleSubmit()}
                loading={connectTenantToTallyLocationLoading}
                disabled={connectTenantToTallyLocationLoading}
              >
                Save and Continue
              </Button>
            </div>
          </div>
        )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, TenantReducers, TallyIntegrationReducers }) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  tallyConnections: TallyIntegrationReducers.tallyConnections,
  connectTenantToTallyLocationLoading: TallyIntegrationReducers.connectTenantToTallyLocationLoading,
  pullTallyProductsLoading: TallyIntegrationReducers.pullTallyProductsLoading,
  pullTallyVendorsLoading: TallyIntegrationReducers.pullTallyVendorsLoading,
});
const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getTallyConnections: (orgId, callback) => dispatch(TallyIntegrationActions.getTallyConnections(orgId, callback)),
  connectTenantToTallyLocation: (payload, callback) => dispatch(TallyIntegrationActions.connectTenantToTallyLocation(payload, callback)),

});

TallyMapUOM.propTypes = {
  user: PropTypes.any,
  getTallyConnectionsLoading: PropTypes.bool,
  getTallyConnections: PropTypes.func,
  connectTenantToTallyLocation: PropTypes.func,
  connectTenantToTallyLocationLoading: PropTypes.bool,
  tallyConnections: PropTypes.any,
  setStep: PropTypes.func,
  stepNumber: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TallyMapUOM));
